import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "../../../components/ui/form";
import { Input } from "../../../components/ui/input";
import { Textarea } from "../../../components/ui/textarea";
import { Button } from "../../../components/ui/button";

const formSchema = z.object({
	name: z.string().min(1, "お名前を入力してください"),
	email: z.string().email("正しいメールアドレスを入力してください"),
	subject: z.string().min(1, "件名を入力してください"),
	message: z.string().min(10, "メッセージは10文字以上で入力してください"),
});

const ContactPage: React.FC = () => {
	const form = useForm<z.infer<typeof formSchema>>({
		resolver: zodResolver(formSchema),
		defaultValues: {
			name: "",
			email: "",
			subject: "",
			message: "",
		},
	});

	const onSubmit = async (values: z.infer<typeof formSchema>) => {
		// TODO: お問い合わせフォームの送信処理を実装
		console.log(values);
	};

	return (
		<Layout>
			<div className="w-full max-w-2xl mx-auto px-4 py-8 md:py-16">
				<h1 className="text-4xl font-bold text-center mb-12">お問い合わせ</h1>

				<div className="bg-white p-6 rounded-lg shadow-md">
					<Form {...form}>
						<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
							<FormField
								control={form.control}
								name="name"
								render={({ field }) => (
									<FormItem>
										<FormLabel>お名前</FormLabel>
										<FormControl>
											<Input {...field} />
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>

							<FormField
								control={form.control}
								name="email"
								render={({ field }) => (
									<FormItem>
										<FormLabel>メールアドレス</FormLabel>
										<FormControl>
											<Input type="email" {...field} />
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>

							<FormField
								control={form.control}
								name="subject"
								render={({ field }) => (
									<FormItem>
										<FormLabel>件名</FormLabel>
										<FormControl>
											<Input {...field} />
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>

							<FormField
								control={form.control}
								name="message"
								render={({ field }) => (
									<FormItem>
										<FormLabel>メッセージ</FormLabel>
										<FormControl>
											<Textarea rows={6} {...field} />
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>

							<Button type="submit" className="w-full">
								送信する
							</Button>
						</form>
					</Form>
				</div>

				<div className="mt-12 p-6 bg-gray-50 rounded-lg">
					<h2 className="text-xl font-semibold mb-4">その他の連絡方法</h2>
					<div className="space-y-4">
						<p>
							<strong>メールアドレス：</strong>
							<a
								href="mailto:info@example.com"
								className="text-blue-500 hover:underline"
							>
								info@example.com
							</a>
						</p>
						<p>
							<strong>電話番号：</strong>
							<a
								href="tel:0123-45-6789"
								className="text-blue-500 hover:underline"
							>
								0123-45-6789
							</a>
						</p>
						<p>
							<strong>受付時間：</strong>平日 9:00〜17:00
						</p>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default ContactPage;
